import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";

interface BrochureStarterProps {}

const BrochureStarterPack: FunctionComponent<BrochureStarterProps> = () => {
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12">
        <div className="mb-12 text-3xl font-bold underline">Kazam Brochure</div>
        <div className="grid lg:grid-cols-3 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://drive.google.com/file/d/1M0edYU7WrrIDgGotUOp67OvXJeULUbLF/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Kazam Product Brochure
              </div>
            </div>
          </a>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default BrochureStarterPack;
